import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

export function getAdminToken() {
  return localStorage.getItem('admin_token');
}

export function setAdminToken(token) {
  localStorage.setItem('admin_token', token);
}

export function clearAdminToken() {
  localStorage.removeItem('admin_token');
}

const client = axios.create({ baseURL: `${API_BASE}/admin` });

client.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If the token expired, boot back to the login screen
client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      clearAdminToken();
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default {
  login: (email, password) => client.post('/login', { email, password }).then(r => r.data),
  getProducts: () => client.get('/products').then(r => r.data),
  createProduct: (product) => client.post('/products', product).then(r => r.data),
  updateProduct: (id, fields) => client.patch(`/products/${id}`, fields).then(r => r.data),
  addLicenseKeys: (productId, keys) => client.post(`/products/${productId}/license-keys`, { keys }).then(r => r.data),
  addLicensePool: (productId, licenseKey, maxSeats) =>
    client.post(`/products/${productId}/license-pools`, { licenseKey, maxSeats }).then(r => r.data),
  getPools: (productId) => client.get(`/products/${productId}/pools`).then(r => r.data),
  getOrders: () => client.get('/orders').then(r => r.data)
};
